export default "__VITE_ASSET__MMGkuOIL__"